<template>
  <div class="part modals select-customer">
    <a-modal
      title="Select A Customer"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="onCreate"
      @cancel="onCancel"
      :centered="true"
      :footer="null"
      :zIndex="1001"
    >
      <!-- table -->
      <ListSkeleton v-if="loading" />
      <a-table
        v-if="!loading && customers && customers.length > 0"
        :loading="loading"
        :columns="columns"
        :dataSource="customers"
        :rowKey="(record, index) => record._id"
        :pagination="pagination"
        @change="updateQuery"
        size="small"
      >
        <span slot="avatar" slot-scope="avatar">
          <a-badge color="blue" dot>
            <a-avatar shape="square" :size="25" :src="avatar" icon="user" />
          </a-badge>
        </span>

        <span slot="name" slot-scope="customer">
          <span class="name">
            <span class="first_name">
              {{ customer.name }}
            </span>
            <span class="last_name" v-if="customer.last_name">
              {{ customer.last_name }}
            </span>
          </span>
        </span>

        <span slot="actions" slot-scope="customer">
          <a-button type="primary" shape="circle" icon="check" size="small" @click="onSelect(customer)" />
        </span>
      </a-table>
    </a-modal>
  </div>
</template>

<script>
import ListSkeleton from '@/components/reno/skeleton/ListSkeleton.vue'

import store from '@/store'
const KEY = 'SELECT_CUSTOMER'
const KEY2 = 'customers'

export default {
  name: 'select-customer-modal',
  components: {
    ListSkeleton,
  },
  data() {
    return {
      confirmLoading: false,
      columns: [
        {
          title: 'ID',
          dataIndex: 'uid',
          key: 'uid',
          fixed: 'left',
          width: 60,
          defaultSortOrder: 'descend',
          sorter: (a, b) => a.uid - b.uid,
        },
        {
          dataIndex: 'avatar',
          key: 'avatar',
          align: 'center',
          width: 30,
          scopedSlots: { customRender: 'avatar' },
        },
        {
          title: this.$t('crm.list.fullname'),
          key: 'name',
          width: 130,
          scopedSlots: { customRender: 'name' },
        },
        {
          title: this.$t('crm.list.location'),
          dataIndex: 'location',
          key: 'location',
          width: 130,
        },
        {
          title: '',
          key: 'actions',
          width: 20,
          scopedSlots: { customRender: 'actions' },
        },
      ],
    }
  },
  computed: {
    loading() {
      return this.$store.getters['crm/loading'](KEY2)
    },
    customers() {
      return this.$store.getters['crm/data'](KEY2)
    },
    pagination() {
      return this.$store.getters['crm/pagination'](KEY2)
    },
    meta() {
      return this.$store.getters['crm/meta'](KEY2)
    },
    visible: {
      get() {
        return this.$store.getters['crm/UI_VISIBLE'](KEY)
      },
      set(visible) {
        this.$store.dispatch('crm/UI_VISIBLE', { key: KEY, visible })
      },
    },
  },
  methods: {
    async fetch() {
      await this.$store.dispatch('crm/fetchCustomers')
    },
    updateQuery: (pagination, filters, sorter) => {
      store.dispatch('crm/updateQuery', { key: KEY2, query: { pagination, filters, sorter } })
    },
    onSelect(customer) {
      if (customer) {
        this.$store.dispatch('pm/setNewProjectCustomer', customer)
      }
      this.visible = false
    },
    onCreate(e) {
      this.visible = false
    },
    onCancel(e) {
      this.visible = false
    },
  },
  mounted() {
    this.fetch()
  },
}
</script>

<style lang="scss" scoped></style>
